import {HostMaps} from 'hiya-common/src/utils/host/AutoHost'

export interface order_log_list_type {
  // 中奖记录
  round_no: string
  ct: string
  bet_coins: number
  win_coins: number
}

export enum ZIndexEnum {
  guidePage = 900,
  loadingPage = 1000,
  coin = 800,
  modal = 9999,
  footer = 2,
  footerActive = 1200,
  stageAreaActive = 1100,
  footerLayer = 1300,
}

export enum StatusEnum {
  // 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  bet = 0,
  preparing = 1,
  showRes = 2,
}
export enum HorseSoundEnum {
  allChips = `${HostMaps.auto.img01}/download/file?obj=mefile/b3/30/bc2c-add7-11ee-b0ae-00163e0442bb` as any,
  chip = `${HostMaps.auto.img01}/download/file?obj=mefile/b8/34/cbc0-add7-11ee-ae81-00163e04069f` as any,
  fail = `${HostMaps.auto.img01}/download/file?obj=mefile/bc/a1/bcab-add7-11ee-b0ae-00163e0442bb` as any,
  win = `${HostMaps.auto.img01}/download/file?obj=mefile/c1/d6/4189-add7-11ee-b0ae-00163e0442bb` as any,
  peoples = `${HostMaps.auto.img01}/download/file?obj=mefile/c5/fe/cced-add7-11ee-ae81-00163e04069f` as any,
  hoof = `${HostMaps.auto.img01}/download/file?obj=mefile/cb/77/3d8c-add7-11ee-ae81-00163e04069f` as any,
  countDown = `${HostMaps.auto.img01}/download/file?obj=mefile/d0/50/a55c-add7-11ee-b0ae-00163e0442bb` as any,
  ring = `${HostMaps.auto.img01}/download/file?obj=mefile/d4/c2/bf4c-add7-11ee-ae81-00163e04069f` as any,
  bg = `${HostMaps.auto.img01}/download/file?obj=mefile/d8/6d/7952-add7-11ee-ae81-00163e04069f` as any,
}
export enum HorseSoundTypeEnum {
  '一堆筹码' = 'allChips',
  '下注筹码' = 'chip',
  '失败' = 'fail',
  '胜利' = 'win',
  '人群声' = 'peoples',
  '马蹄声' = 'hoof',
  '倒计时3s' = 'countDown',
  '比赛铃声' = 'ring',
  '背景音' = 'bg',
}

export enum seat_type_enum {
  // : 座位类型;1:富豪位;2:观众席
  richMan = 1,
  nomal = 2,
}

export enum seat_status_enum {
  // 0:空位;1:有人
  vacant = 0,
  avaliable,
}
export enum relation_type_enum {
  同房间 = 1,
  好友 = 2,
}

export interface seat_list_item {
  seat_id?: number
  player_icon: string
  player_mid: number
  player_name: string
  seat_type?: seat_type_enum
  // 赢钱数目
  win_num?: number
  // 当前座位上是否有人
  status: seat_status_enum
  relation_type?: relation_type_enum
  // 针对guset的情况
  user_num?: number
}
export interface bet_detail_item {
  chip_value: number
  chip_num: number
}

export interface history_result_item {
  round_no: string
  win_pos: number
}

// 相关DOM操作
export interface imgProps {
  src: string
  top: number
  left: number
  width: number
  height: number
  className?: string
}
// 下注状态
export enum bet_status_enum {
  failed = 0,
  suc = 1,
  outOfCoin = 2,
}
// 获取轮次结果
export interface win_list_item {
  seat_id: number
  win_num: number
}

export interface winner_type {
  ct: number
  bet_coins: number
  bet_user_name: string
  bet_user_avatar: string
  jackpot_reward: number
}
